import React, { useEffect, useState } from 'react';
import styles from './TipBoxTop.module.scss';

/* Providers */
import { useShopContext } from '../../../../shared/__providers__/ShopContext';
import { useAnalyticsHandlers } from '../../../../../../analytics/__providers__/AnalyticsHandlersProvider';

/* Components */
import { TipMatchForecastInfo } from '../MatchForecast/TipMatchForecastInfo';
import { BookieButton } from '../../../containers/TipComponents/BookieButton';

/* Types */
import {
  UnlockedMatchForecast,
  UnlockedTipData,
} from '../../../../../../store/tips/reducer';
import { AppboyLogTypes } from '../../../../../../analytics/AppboyAnalyticsHandler';
import { TipProduct } from '../../../interfaces/TipProduct';
import { CredentialsUserObject } from '../../../../../../types/Login';

/* Redux */
import { RootState } from '../../../../../../store';
import { userSelector } from '../../../../../../store/tipster/selector';
import { connect } from 'react-redux';

interface TipBoxTopProps {}
interface ReduxProps {
  user: CredentialsUserObject;
}
export const UnlockedTipBoxTop: React.FC<TipBoxTopProps & ReduxProps> = ({
  user,
}) => {
  const { shop } = useShopContext();
  const tip = shop!.selectedProduct as TipProduct;
  const analytics = useAnalyticsHandlers();
  const [isTracked, setIsTracked] = useState<boolean>(false);

  useEffect(() => {
    user &&
      analytics!.client.BIEvent.log('WEB_TIP_VIEWED', {
        values: [{ tip_id: tip.tip.id }],
        userID: user.id,
      });

    if (user && !isTracked) {
      analytics?.client.Mixpanel.log('WEB_TIP_VIEWED', [
        {
          tipster_id: tip.tipster.ID,
          tipster_name: tip.tipster.name,
          tip_id: tip.tip.id,
        },
      ]);
    }
    setIsTracked(true);

    //delay to ensure appboy is initialized
    setTimeout(() => {
      analytics!.client &&
        analytics!.client.appboy.log('Viewed Web Tip', {
          logType: AppboyLogTypes.CUSTOM,
          values: [
            {
              tip_id: tip.tip.id,
              tipster_id: tip.tipster.ID,
              tipster_name: tip.tipster.name,
            },
          ],
        });
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {tip && (
        <div className={styles.innerTopBox}>
          <div className={styles.unlocked}>
            {!!(tip.tip as UnlockedTipData).match_forecasts &&
              (tip.tip as UnlockedTipData).match_forecasts.map(
                (forecast: UnlockedMatchForecast) => (
                  <TipMatchForecastInfo forecast={forecast} key={forecast.id} />
                ),
              )}
          </div>
        </div>
      )}
      <BookieButton tip={tip} isTipster={user ? user.is_tipster : false} />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  user: userSelector(state),
});

export const UnlockedTipBoxTopConnected =
  connect(mapStateToProps)(UnlockedTipBoxTop);
